"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryDealerIdDto = void 0;
class InventoryDealerIdDto {
    constructor(params) {
        this.name = "";
        this.value = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.name = params.name;
        this.value = params.value;
        this.inventoryProviderId = params.inventoryProviderId;
        this.flickFusionId = params.flickFusionId;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
    }
}
exports.InventoryDealerIdDto = InventoryDealerIdDto;
//# sourceMappingURL=InventoryDealerIdDto.js.map